import DocumentViewer from "lib/DocumentViewer";
import React, { Fragment, useEffect, useState } from "react";

const RecursiveUpload = (props) => {
  const { selectedData, name: document_name, className } = props;

  const [multipleUplodedDocs, setMultipleUplodedDocs] = useState([]);

  useEffect(() => {
    if (document_name) {
      const uploadedDocs = [];
      for (const [key, value] of Object.entries(selectedData)) {
        if (key.includes(`${document_name}-`)) {
          uploadedDocs.push({ ...value, name: key, label: document_name });
        }
      }
      setMultipleUplodedDocs(uploadedDocs);
    }
  }, [props]);

  const getLabelInProperFormat = (label, index) => {
    const labelArray = label && label.split("_");
    const labelInProperFormat = labelArray
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
    return `${labelInProperFormat} ${index + 1}`;
  };

  return (
    <>
      {multipleUplodedDocs?.length > 0 &&
        multipleUplodedDocs.map((doc, index) => {
          return (
            <div className={`.view_card_container ${className} `}>
              <Fragment key={index}>
                <DocumentViewer
                  classNameOrMargin={"p-1"}
                  {...props}
                  name={doc?.name}
                  selectedData={{ documents: { [doc?.name]: doc } }}
                  label={getLabelInProperFormat(doc?.label, index)}
                />
                {/* </div> */}
              </Fragment>
            </div>
          );
        })}
    </>
  );
};

export default RecursiveUpload;
